module.exports = __webpack_public_path__ + "static/img/curseur-actif-frames.3c42be6.gif";


//////////////////
// WEBPACK FOOTER
// ./src/components/instructions/img/curseur-actif-frames.gif
// module id = n5rM
// module chunks = 0